import './SideMenu.css';
import { useLocation, useNavigate } from 'react-router-dom';
import Logo from '../../img/final_logo.png';
import CryptoJS from 'crypto-js';

function SideMenu() {
    const navigate = useNavigate();
    const { pathname, search, state } = useLocation();

    const handleLinkClick = (e, target) => {
        e.preventDefault();
        const link = typeof target === 'string' ? target : target.link;
        const targetState = typeof target === 'object' ? target.state : undefined;

        if (link === '/') {
            // Logout - clear session
            const wasVendor = sessionStorage.getItem('ID_CardAdmin_user_role') === 'vendor';
            sessionStorage.removeItem('ID_CardAdmin_user');
            sessionStorage.removeItem('ID_CardAdmin_user_auth');
            sessionStorage.removeItem('ID_CardAdmin_user_role');
            navigate(wasVendor ? '/vendor-login' : '/login');
            return;
        }
        navigate(link, targetState ? { state: targetState } : undefined);
    };

    // User role checks
    const role = sessionStorage.getItem('ID_CardAdmin_user_role');
    const isVendor = role === 'vendor';
    const isSchool = role === 'school';

    // Current tab for /download-cards
    const currentDownloadTab = new URLSearchParams(search).get('tab') || 'single';

    // Tabs definition
    let tabs = [];

    if (isVendor) {
        tabs = [
            {
                heading: 'Schools under vendor',
                link: '/vendor-schools',
                activeRoutes: ['/vendor-schools']
            },
            {
                heading: 'Logout',
                link: '/',
                activeRoutes: ['/']
            }
        ];
    } else if (isSchool) {
        let schoolUserObj = null;
        try {
            schoolUserObj = JSON.parse(sessionStorage.getItem('ID_CardAdmin_user'));
        } catch (e) {
            console.error(e);
        }

        const schoolId = schoolUserObj?.schoolid;

        tabs = [
            {
                heading: 'Dashboard',
                link: '/dashboard',
                activeRoutes: ['/dashboard', `/schools/${schoolId}`],
                state: schoolUserObj
            },
            {
                heading: 'Download Cards',
                link: '/download-cards',
                activeRoutes: ['/download-cards'],
                subItems: [
                    { title: 'Single Card', link: '/download-cards?tab=single', tab: 'single' },
                    { title: 'Multiple Cards', link: '/download-cards?tab=multiple', tab: 'multiple' },
                    { title: 'Download by Class', link: '/download-cards?tab=class', tab: 'class' },
                ]
            },
            {
                heading: 'Logout',
                link: '/',
                activeRoutes: ['/']
            }
        ];
    } else {
        // Super Admin tabs
        tabs = [
            {
                heading: 'ID Cards',
                link: '/idcards',
                activeRoutes: ['/idcards', `/idcards/${state?.id}`, '/idcards/create', '/download-by-excel']
            },
            {
                heading: 'Template Prompt',
                link: '/school-setup?view=admin',
                activeRoutes: ['/school-setup']
            },
            {
                heading: 'Download Cards',
                link: '/download-cards',
                activeRoutes: ['/download-cards'],
                subItems: [
                    { title: 'Single Card', link: '/download-cards?tab=single', tab: 'single' },
                    { title: 'Multiple Cards', link: '/download-cards?tab=multiple', tab: 'multiple' },
                    { title: 'Download by Class', link: '/download-cards?tab=class', tab: 'class' },
                ]
            },
            {
                heading: 'Download by Date',
                link: '/download-by-date',
                activeRoutes: ['/download-by-date']
            },
            {
                heading: 'Download by School',
                link: '/download-by-school',
                activeRoutes: ['/download-by-school']
            },
            {
                heading: 'Download by Class',
                link: '/download-by-class',
                activeRoutes: ['/download-by-class']
            },
            {
                heading: 'Users',
                link: '/users',
                activeRoutes: ['/users']
            },
            {
                heading: 'Schools',
                link: '/schools',
                activeRoutes: ['/schools', `/schools/${state?.schoolid}`, `/schools/class/${state?.classid}`]
            },
            {
                heading: 'Logout',
                link: '/',
                activeRoutes: ['/']
            }
        ];
    }

    // Skip auth check for vendors & schools
    if (!isVendor && !isSchool && sessionStorage?.getItem('ID_CardAdmin_user_auth')) {
        const bytes = CryptoJS.AES.decrypt(sessionStorage?.getItem('ID_CardAdmin_user_auth'), process.env.REACT_APP_CRYPTO_JS_SECRET);
        const decrypt = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        if (decrypt) return;
    }

    if (pathname === '/login' || pathname === '/vendor-login') return;

    return (
        <div id='sidemenu'>
            <section className='sidemenu_cont'>
                <div className='logo_container'>
                    <img className='sidemenu_logo' src={Logo} alt="Logo" />
                </div>
                <div className="sidemenu_sec1">
                    {tabs.map((t, i) => {
                        let isActive = false;
                        if (isSchool && t.heading === 'Dashboard') {
                            isActive = pathname === '/dashboard' || pathname.startsWith('/schools/');
                        } else if (isVendor && t.heading === 'Schools under vendor') {
                            isActive = pathname.startsWith('/vendor-schools');
                        } else {
                            isActive = t.activeRoutes.includes(pathname);
                        }

                        const showSubItems = t.subItems && (pathname === '/download-cards' || isSchool);

                        return (
                            <div key={i}>
                                <div
                                    onClick={e => handleLinkClick(e, t)}
                                    className={`sidemenu_btn ${isActive ? 'sidemenu_btn_active' : ''}`}
                                >
                                    {t.heading}
                                </div>

                                {showSubItems && (
                                    <div className="sidemenu_subCont">
                                        {t.subItems.map((sub, subIdx) => {
                                            const isSubActive = pathname === '/download-cards' && currentDownloadTab === sub.tab;
                                            return (
                                                <div
                                                    key={subIdx}
                                                    onClick={e => handleLinkClick(e, sub.link)}
                                                    className={`sidemenu_subBtn ${isSubActive ? 'sidemenu_subBtn_active' : ''}`}
                                                >
                                                    <span className="sidemenu_subBtn_dot"></span>
                                                    {sub.title}
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            </section>
        </div>
    );
}

export default SideMenu;
